import type { IMovementType, IMovementTypeGroup, MovementCounts } from '@/entities/movement-type/types';
import { priorityMap } from './consts.ts';
import { type TMovementType, type TMovementTypeGroup } from '@/entities/movement-type/types';

export function sortAndFilterMovementItems(
  counts: Partial<MovementCounts>,
  movementTypeGroups: IMovementTypeGroup[],
  movementTypes: IMovementType[],
): (IMovementType | IMovementTypeGroup)[] {
  const result: (IMovementType | IMovementTypeGroup)[] = [];
  const usedTypes = new Set<string>();

  // Обработка групп
  movementTypeGroups.forEach((group) => {
    if (
      group.types.some(
        (type) => typeof type === 'string' && type in counts && counts[type as keyof MovementCounts] !== undefined,
      )
    ) {
      result.push({ ...group, isSelected: false });
      group.types.forEach((type) => {
        if (typeof type === 'string') {
          usedTypes.add(type);
        }
      });
    }
  });

  // Обработка отдельных типов
  movementTypes.forEach((type) => {
    if (
      typeof type.str === 'string' &&
      type.str in counts &&
      counts[type.str as keyof MovementCounts] !== undefined &&
      !usedTypes.has(type.str)
    ) {
      result.push({ ...type, isSelected: false });
    }
  });

  // Сортировка результата
  result.sort((a, b) => {
    const aPriority =
      typeof a.str === 'string' ? (priorityMap[a.str as TMovementType & TMovementTypeGroup] ?? Infinity) : Infinity;
    const bPriority =
      typeof b.str === 'string' ? (priorityMap[b.str as TMovementType & TMovementTypeGroup] ?? Infinity) : Infinity;

    return aPriority - bPriority;
  });

  return result;
}
